/**
 * GxStickyBar: the one bottom bar (the Decide step bar, the card page's Choose bar, the finale's stage bar, the chair's practice foot).
 * A fixed height (`--gx-bar-min`), a top edge and a shadow, and it sits in the page's flow at the end of the column, so the content's last
 * line is never under it; mid-page it floats over the scroll with a fade. `html` carries `scroll-padding-bottom` so a focused field or an
 * anchor jump is never left behind it. The page's root takes `gx-bar-room` (padding the height of the bar) when its last element is not the bar.
 * `lead` is the sentence of the bar (what is still needed), `children` its actions, once: a page never repeats the same primary action in its body.
 */
import type { ReactNode } from "react";
import "./system.css";

export function GxStickyBar({ lead, children, testId, className = "" }: { readonly lead?: ReactNode; readonly children?: ReactNode; readonly testId?: string; readonly className?: string }) {
  return (
    <div className={`gx-sticky-bar ${className}`.trim()} data-testid={testId}>
      {lead === undefined ? null : <div className="gx-sticky-bar-lead">{lead}</div>}
      {children === undefined ? null : <div className="gx-sticky-bar-acts">{children}</div>}
    </div>
  );
}
